import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_EMAIL_RECIPIENT_SOURCES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { getField, updateField } from 'vuex-map-fields'

const workflowEmailRecipientSources = {
  namespaced: true,
  state: buildInitialState({
    workflowEmailRecipientSourceList: []
  }),
  getters: { getField },
  actions: {
    getWorkflowEmailRecipientSources ({ commit, state }) {
      if (state.workflowEmailRecipientSourceList.length > 0) {
        return Promise.resolve(state.workflowEmailRecipientSourceList)
      }

      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_WORKFLOW_EMAIL_RECIPIENT_SOURCES })
        .then(json => json.data)
        .then(sources => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowEmailRecipientSources', sources)
          return sources
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowEmailRecipientSources (state, sources) {
      state.workflowEmailRecipientSourceList = sources
    }
  }
}

export default workflowEmailRecipientSources
